export const USE_DASHBOARD_SETTINGS_QUERY_KEY = 'dashboardSettings';
